module.exports = __webpack_public_path__ + "img/ptofile-close-transparent-home-bottom.e6fa80bf.png";